import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, Icon, toast } from '@livable/saas-react-components';
import { Alert, Button, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { useStore } from 'src/stores';
export const GetForm = observer(_ref => {
  let handleModalClose = _ref.handleModalClose,
    triggerRefresh = _ref.triggerRefresh,
    singlePropertyObj = _ref.singlePropertyObj;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    portfoliosData = _useState2[0],
    setPortfoliosData = _useState2[1];
  const batchSelectedPropertiesUnicPortfolioIds = Array.from(new Set(toJS(store.portfoliosMultiActionStore.selectedItems.map(i => i.currentPortfolioId))));
  const isPropertiesInSamePortfolio = batchSelectedPropertiesUnicPortfolioIds.length === 1;
  const _useState3 = useState((singlePropertyObj === null || singlePropertyObj === void 0 ? void 0 : singlePropertyObj.currentPortfolioId) || isPropertiesInSamePortfolio && batchSelectedPropertiesUnicPortfolioIds[0] || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedPortfolioId = _useState4[0],
    setSelectedPortfolioId = _useState4[1];
  const fetchPortfolios = async () => {
    const resp = await store.portfolios.getPortfoliosDashboardAsync.run();
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      setPortfoliosData(resp === null || resp === void 0 ? void 0 : resp.response.portfolios);
    }
  };
  const getIsLoading = () => {
    return store.portfolios.getPortfoliosDashboardAsync.inProgress || store.portfolios.transferPortfoliosAsync.inProgress;
  };
  const getIsConfirmDisabled = () => {
    return selectedPortfolioId === '' || selectedPortfolioId === (singlePropertyObj === null || singlePropertyObj === void 0 ? void 0 : singlePropertyObj.currentPortfolioId) || isPropertiesInSamePortfolio && batchSelectedPropertiesUnicPortfolioIds[0] === selectedPortfolioId;
  };
  const assignPropertiesToPortfolio = async _ref2 => {
    let targetPortfolioId = _ref2.targetPortfolioId,
      propertyIds = _ref2.propertyIds;
    return store.portfolios.transferPortfoliosAsync.run({
      targetPortfolioId: targetPortfolioId,
      propertyIds: propertyIds
    });
  };
  const confirmMoving = async event => {
    event.stopPropagation();
    const resp = await assignPropertiesToPortfolio({
      targetPortfolioId: selectedPortfolioId,
      propertyIds: singlePropertyObj ? [singlePropertyObj.propertyId] : toJS(store.portfoliosMultiActionStore.selectedItems).map(i => i.propertyId)
    });
    if (resp !== null && resp !== void 0 && resp.isSuccessful) {
      toast('success', {
        body: ['Successfully moved']
      });
      store.portfoliosMultiActionStore.deselectAll();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      triggerRefresh && triggerRefresh();
      handleModalClose();
    }
  };
  useEffect(() => {
    fetchPortfolios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('portfolios_properties_page.move_properties_to_portfolio_description'))), /*#__PURE__*/React.createElement("div", {
    className: classes.formContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('portfolios_properties_page.select_destination_portfolio'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, portfoliosData.map(item => /*#__PURE__*/React.createElement(RadioGroup, {
    className: classes.portfoliosRadioGroup
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "female",
    control: /*#__PURE__*/React.createElement(Radio, {
      checked: selectedPortfolioId === item.id,
      onChange: () => setSelectedPortfolioId(item.id),
      value: item.id
    }),
    label: /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: classes.collaborator
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "folder-house"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "body"
    }, item.name))
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose,
    'custom-attribute': '673-new-billing-module'
  }, t('buttons.cancel')))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    onClick: event => confirmMoving(event),
    disabled: getIsLoading() || getIsConfirmDisabled(),
    'custom-attribute': '674-new-billing-module'
  }, t('portfolios_properties_page.move')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: getIsLoading()
  }));
});